export default __webpack_public_path__ + "static/media/cursor-video.1398c623.svg";